import React from "react";
import { BookOpen, Flame, Layers, Trophy, TrendingUp, Hammer, Zap, Crown } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

const ICONS = {
    first_book: BookOpen, streak10: Flame, cards100: Layers, quiz90: Trophy,
    words100k: TrendingUp, builder: Hammer, fast_learner: Zap, master_reader: Crown,
};

export const AchievementsGrid = ({ achievements = [] }) => {
    const { t } = useTranslation();
    return (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="achievements-grid">
            {achievements.map((a) => {
                const Icon = ICONS[a.key] || Trophy;
                // Prefer localized labels by stable key; fall back to server-provided text.
                const label = t(`achievements.items.${a.key}.label`);
                const desc = t(`achievements.items.${a.key}.desc`);
                const finalLabel = label === `achievements.items.${a.key}.label` ? a.label : label;
                const finalDesc = desc === `achievements.items.${a.key}.desc` ? a.desc : desc;
                return (
                    <div key={a.key} className={`flex flex-col items-center gap-2 rounded-2xl border p-4 text-center transition-colors ${a.earned ? "border-[hsl(var(--primary))]/40 bg-surface-2" : "border-border bg-surface-1"}`}>
                        <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${a.earned ? "bg-[hsl(var(--primary))]/15 text-[hsl(var(--primary))]" : "bg-surface-3 text-t4"}`}>
                            <Icon className="h-5 w-5" />
                        </div>
                        <div>
                            <div className={`text-xs font-medium ${a.earned ? "text-t1" : "text-t3"}`}>{finalLabel}</div>
                            <div className="mt-0.5 text-[10px] text-t4">{finalDesc}</div>
                        </div>
                        {!a.earned && (
                            <div className="mt-1 h-1 w-full overflow-hidden rounded-full bg-surface-3">
                                <div className="h-full rounded-full bg-[hsl(var(--primary))]/60 transition-all duration-500" style={{ width: `${a.progress || 0}%` }} />
                            </div>
                        )}
                        {a.earned && <span className="mono-label rounded-full bg-[hsl(var(--primary))]/15 px-2 py-0.5 text-[9px] text-[hsl(var(--primary))]">{t("achievements.earned")}</span>}
                    </div>
                );
            })}
        </div>
    );
};
